<template>
  <div class="text-center">
    <v-dialog v-model="show" width="60%" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Cadastrar Aluno
        </v-card-title>

        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-file-input
                v-model="files"
                multiple
                small-chips
                outlined
                dense
                label="Selecione arquivos"
                truncate-length="20"
                @change="atualizarTabela()"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip rounded small :key="index" close @click:close="removerArquivo(index)">
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <v-select
                v-model="anoLetivoSelecionado"
                :items="anoLetivo"
                label="Ano Letivo"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="4">
              <v-select
                v-model="anoEscolarSelecionado"
                :items="anoEscolar"
                label="Ano Escolar"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select v-model="turmaSelecionada" :items="turma" label="Turma" outlined dense hide-details> </v-select>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="itensTabela"
            :footer-props="footerProps"
            :no-data-text="'Adicione alunos para mostrá-los na tabela'"
            class="elevation-2 mt-4"
          >
            <template v-slot:item.aluno="{ item }">
              <v-autocomplete
                v-model="item.alunoSelecionado"
                :items="alunos.content"
                outlined
                dense
                item-text="nome"
                label="Selecionar alunos"
                return-object
                single-line
                hide-details
              ></v-autocomplete>
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip :color="getStatusColor(item.status)" dark>
                {{ item.status }}
                <v-icon right>
                  {{ getIcon(item.status) }}
                </v-icon>
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item, index }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon style="cursor: pointer;" color="red" @click="removerAluno(item, index)">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="red" dark @click="fechar()">
            Fechar
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="enviarArquivos()" :disabled="!liberarBotao">
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AlunoService from "../../service/AlunoService";
import SondagemInfantilService from "@/service/SondagemInfantilService";

export default {
  name: "CadastrarAluno",
  props: {
    show: Boolean,
  },

  data() {
    return {
      files: [],
      itensTabela: [],
      anoAtual: undefined,

      alunos: [],

      anoLetivo: [],
      anoLetivoSelecionado: null,

      anoEscolar: [],
      anoEscolarSelecionado: null,
      anoEscolarRequest: "",

      turma: [],
      turmaSelecionada: null,

      footerProps: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [5],
      },

      headers: [
        {
          text: "Arquivo",
          value: "arquivo",
          align: "center",
        },
        {
          text: "Aluno",
          value: "aluno",
          align: "center",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false,
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    removerAluno(item, index) {
      this.itensTabela.splice(index, 1);

      const fileIndex = this.files.findIndex((f) => f.name === item.arquivo);

      if (fileIndex !== -1) {
        this.files.splice(fileIndex, 1);
      }
    },

    getStatusColor(status) {
      switch (status) {
        case "Pendente":
          return "grey";
        case "Enviando...":
          return "orange";
        case "Concluído":
          return "green";
        case "Erro":
          return "red";
        default:
          return "grey";
      }
    },

    getIcon(status) {
      switch (status) {
        case "Pendente":
          return "mdi-timer-sand";
        case "Enviando...":
          return "mdi-progress-upload";
        case "Concluído":
          return "mdi-check-circle";
        case "Erro":
          return "mdi-alert-circle";
        default:
          return "";
      }
    },

    async enviarArquivos() {
      for (const item of this.itensTabela) {
        if (item.status === "Pendente" || item.status === "Erro") {
          try {
            item.status = "Enviando...";

            this.anoEscolarRequest = this.anoEscolarSelecionado.replace("°", "");

            await SondagemInfantilService.cadastrarSondagem(
              item.alunoSelecionado.id,
              this.anoLetivoSelecionado,
              this.anoEscolarRequest,
              this.turmaSelecionada,
              item.arquivoCompleto
            );

            item.status = "Concluído";
          } catch (error) {
            console.error("Erro ao enviar o arquivo: ", error);
            item.status = "Erro";
          } finally {
            this.$emit("recarregarItensTabela");
          }
        }
      }
    },

    buscarAlunosPorRA(ra) {
      return this.alunos.content.find((aluno) => (aluno.ra + '-' + aluno.digRa) === ra);
    },

    obterNomeArquivoCompleto(nomeCompleto) {
      const indiceUltimoPonto = nomeCompleto.lastIndexOf(".");

      if (indiceUltimoPonto === -1) {
        return nomeCompleto;
      }

      const nomeArquivo = nomeCompleto.substring(0, indiceUltimoPonto);
      return nomeArquivo;
    },

    atualizarTabela() {
      this.itensTabela = this.files.map((file) => ({
        arquivo: file.name,
        arquivoCompleto: file,
        alunoSelecionado: this.buscarAlunosPorRA(this.obterNomeArquivoCompleto(file.name)),
        status: "Pendente",
      }));
    },

    removerArquivo(index) {
      this.files.splice(index, 1);
      this.atualizarTabela();
    },

    async buscarAlunos() {
      try {
        const response = await AlunoService.buscarListaDeAlunos();
        this.alunos = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    setAnoLetivo() {
      for (let ano = 2020; ano <= this.anoAtual; ano++) {
        this.anoLetivo.push(ano.toString());
      }

      this.anoLetivoSelecionado = undefined;
    },

    setAnos() {
      this.anoEscolar = ["1°", "2°", "3°", "4°", "5°", "6°", "7°", "8°", "9°"];

      this.anoEscolarSelecionado = undefined;
    },

    setTurma() {
      this.turma = ["A", "B", "C", "D", "E", "F", "G", "H"];

      this.turmaSelecionada = undefined;
    },

    fechar() {
      this.files = [];
      this.itensTabela = [];
      this.setAnos();
      this.setTurma();
      this.setAnoLetivo();

      this.$emit("fechar");
    },
  },

  computed: {
    liberarBotao() {
      const todosOsArquivosSelecionados = this.itensTabela.every(
        (item) => item.alunoSelecionado && item.alunoSelecionado.id
      );

      const arquivosValidos = this.files && this.files.length > 0;
      const anoLetivoValido = this.anoLetivoSelecionado && this.anoLetivoSelecionado.length > 0;
      const anoEscolarValido = this.anoEscolarSelecionado && this.anoEscolarSelecionado.length > 0;
      const turmaValida = this.turmaSelecionada && this.turmaSelecionada.length > 0;

      return todosOsArquivosSelecionados && arquivosValidos && anoLetivoValido && anoEscolarValido && turmaValida;
    },
  },

  created() {
    this.anoAtual = new Date().getFullYear();

    this.buscarAlunos();
    this.setAnos();
    this.setTurma();
    this.setAnoLetivo();
  },
};
</script>

<style scoped></style>
